module.exports = __webpack_public_path__ + "img/blueArrows.84c50d0d.png";